export default __webpack_public_path__ + "static/Entenda0071-5cd4e7eb6e288da34c9b5a66a1af8513.jpg";